import {
  Button, Group, Collapse, Box,
} from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import {
  IconCircleChevronDown,
  IconCircleChevronUp,
} from '@tabler/icons-react';
import PropTypes from 'prop-types';
import classes from './collapse.module.css';

const CollapseComponent = ({ label, children }) => {
  const [opened, { toggle }] = useDisclosure(true);

  return (
    <Box className={classes.box} mx="auto" mb="md">
      <Group className={classes.group} justify="space-between">
        <strong>{label}</strong>
        <Button className={classes.button} onClick={toggle} variant="subtle">
          {opened ? <IconCircleChevronUp className={classes.icon}/>
            : <IconCircleChevronDown className={classes.icon}/>}
        </Button>
      </Group>

      <Collapse className={classes.collapse} in={opened}>
        <Box mt="md">
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};

CollapseComponent.propTypes = {
  label: PropTypes.any.isRequired,
  children: PropTypes.node.isRequired,
};

export default CollapseComponent;
